import React from 'react';
import { useSelector } from 'react-redux';
import { getSelectedWebsiteDomain } from '../store/tracked_websites/selectors';
import { overviewSettings, tabsSettings } from './settings';
import BacklinksOverview from './overview/BacklinksOverview';
import BacklinksTabs from './results/BacklinksTabs';

export default function Backlinks() {
	const domain = useSelector((state) => getSelectedWebsiteDomain(state) as string);

	return (
		<div className="backlinks">
			<BacklinksOverview domain={domain} settings={overviewSettings} showChart={true} />
			<BacklinksTabs domain={domain} settings={tabsSettings} />
		</div>
	);
}
